import { render, staticRenderFns } from "./MoleculeConfirmForgotPassword.vue?vue&type=template&id=6488b6ea"
import script from "./MoleculeConfirmForgotPassword.vue?vue&type=script&lang=js"
export * from "./MoleculeConfirmForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports